import { cn } from "@/lib/utils";
import { thumbUrl } from "@/lib/image-thumb";

type CollectorSocialProofProps = {
  count: number;
  people: {
    id: string;
    username: string;
    display_name: string | null;
    avatar_url: string | null;
  }[];
  className?: string;
};

export function CollectorSocialProof({
  people,
  className,
}: CollectorSocialProofProps) {
  const shown = people.slice(0, 5);

  return (
    <div
      className={cn(
        "inline-flex items-center gap-3 rounded-full bg-transparent px-4 py-2.5",
        className
      )}
    >
      <div className="flex items-center">
        {shown.map((p, i) => (
          <img
            key={p.id}
            src={
              thumbUrl(p.avatar_url, 64) ||
              `https://api.dicebear.com/7.x/initials/svg?seed=${p.username}`
            }
            alt={p.display_name ?? p.username}
            loading="lazy"
            decoding="async"
            width={28}
            height={28}
            className="h-7 w-7 rounded-full border border-white bg-muted object-cover"
            style={{ marginLeft: i === 0 ? 0 : -10 }}
          />
        ))}
      </div>
      <div className="flex flex-col items-start gap-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-foreground">4.9</span>
          <div className="relative inline-flex items-center">
            {/* Empty stars track */}
            <div className="flex items-center gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <StarEmpty key={i} />
              ))}
            </div>
            {/* Filled stars overlay clipped to 98% (4.9/5) */}
            <div
              className="absolute left-0 top-0 flex items-center gap-0.5 overflow-hidden"
              style={{ width: "98%" }}
            >
              {Array.from({ length: 5 }).map((_, i) => (
                <StarFilled key={i} />
              ))}
            </div>
          </div>
        </div>
        <span className="text-[11px] font-medium leading-none text-foreground">
          amado por +1.000 colecionadores
        </span>
      </div>
    </div>
  );
}

function StarEmpty({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      className={cn("shrink-0", className)}
    >
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        stroke="currentColor"
        strokeWidth="1.5"
        className="text-foreground/25"
      />
    </svg>
  );
}

function StarFilled({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={cn("shrink-0 text-[#F59E0B]", className)}
    >
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );
}
